// import './pdfview.css';
import '../../components/pdf/pdfview.css'

import React, { useState, useEffect } from 'react';

// import { getfileurl } from '../../services/ecm'

const Pdfviewer = ({id}) => {
//   let datalink = props.location;

//   console.log(datalink)
//   const [Id, setId] = useState(0);
//   const [file, setfile] = useState([]);

// console.log(Id)
//   useEffect(() => {
//     try {
//       if (datalink && (datalink.id === "" || datalink.id === undefined)) return;
//       if (datalink && datalink.id !== "") {
//         setId(datalink.id);
//       }
//     } catch {

//     }
//   }, [datalink]);

  // useEffect(() => {
  //   if (Id==0) return;

  //   const loadDta = async () => {

  //     const { data: result } = await getfileurl(Id);
  //     if (result) {
  //       setfile(result);
  //     }
  //   };
  //   loadDta();
  // }, [Id]);

  // if ((!file)) return
  <></>
  return (
    <div className="Pdf">
      { id && <iframe
        id="pdf-js-viewer"
        src={id} 
     //   src={"lib/web/viewer.html?url=https://wms.advanceagro.net/ws2/Data/File/DA/3-1.pdf"}
        // src="lib/web/viewer.html?file=../../sample.pdf"
        title="webviewer"
        frameBorder="0"
        width="100%"
        height="100%"
      ></iframe>}
    </div>
  );
}

export default Pdfviewer;